<template>
  <FourElement />
  <div class="collection-container">
    <Filter />
    <List />
    <div v-if="dataSource && dataSource.length > 0">
      <div class="fs14 lh30 fl" style="color: #999999;">
        {{
          `共 ${pagination.total} 条记录，第${pagination.pageNum} / ${~~(
            pagination.total / pagination.pageSize
          ) +
            (pagination.total % pagination.pageSize
              ? 1
              : pagination.total === 0
              ? 1
              : 0)}页`
        }}
      </div>
      <div
        style="display: flex; flex-direction: row; float: right; padding-bottom: 50px;"
      >
        <a-pagination
          v-if="pagination.pageSize"
          class="mr20"
          v-model:current="pagination.pageNum"
          :total="pagination.total"
          v-model:pageSize="pagination.pageSize"
          :showTotal="() => false"
          :showSizeChanger="false"
          @change="initList"
        />
        <a-select
          class="mr10"
          style="min-width: 80px;"
          v-model:value="pagination.pageSize"
          @change="initList"
          placeholder="条"
          :options="[
            { value: 10, label: 10 },
            { value: 20, label: 20 },
            { value: 30, label: 30 },
            { value: 40, label: 40 },
            { value: 50, label: 50 }
          ]"
        >
        </a-select>
        <div class="lh30 mr10">条/页</div>
        <div class="lh30 mr10">跳转至</div>
        <a-input-number
          class="mr10"
          style="width: 50px;"
          :value="pagination.pageNum"
          placeholder="页"
          :max="
            pagination.total <= pagination.pageSize
              ? 1
              : Math.ceil(pagination.total / pagination.pageSize)
          "
          :min="1"
          @change="watchPage"
        />
        <div class="lh30">页</div>
      </div>
    </div>
  </div>
  <EditModal />
  <!-- <BigPic /> -->
</template>
<script>
import { toRefs, reactive, provide, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import FourElement from './components/FourElement'
// import BigPic from './components/BigPic'
import Filter from './components/Filter'
import EditModal from './components/EditModal'
import List from './components/List'
import useAPI from 'UseApi'
import { message, Modal } from 'ant-design-vue'
// import { common_lang_get } from '@/server/modules/3426.js'
import { abtest_select_post } from '@/server/modules/10982.js'
import {
  theme_coldWarm_page_get,
  theme_coldWarm_themeList_get,
  theme_coldWarm_add_post,
  theme_coldWarm_enable_post,
  theme_coldWarm_delete_id_delete,
  theme_coldWarm_detail_id_get,
  theme_coldWarm_edit_post
} from '@/server/modules/17134.js'
const {
  common_querySiteInfo_get_
  // payMethod_listConfig_post_,
  // payMethod_saveConfig_post_,
  // payMethod_deleteConfig_post_
  // payMethod_changeSort_post_
} = useAPI(null, [3426, 4240, 5922, 7567, 6566])
export default {
  components: {
    FourElement,
    EditModal,
    List,
    // BigPic,
    Filter
  },
  setup() {
    const state = reactive({
      filterForm: {
        areaCodes: null,
        enable: null
      },
      areaList: [],
      modalAreaList: [],
      formState: {
        enable: null,
        themeTypeSort: [],
        areaCodes: []
      },
      countrys: [],
      states: [],
      async getCountryState() {
        const countryRes = await abtest_select_post({
          countryRegionType: 0,
          pageNum: 1,
          pageSize: 500
        })
        const stateRes = await abtest_select_post({
          countryRegionType: 1,
          pageNum: 1,
          pageSize: 5000
        })
        if (countryRes.success) {
          const countrys = countryRes.data.list
          const states = stateRes.data.list
          countrys.map((item, index) => (item.key = index))
          states.forEach((item, idx) => {
            const index = countrys.findIndex(n => n.id === item.parentId)
            if (index >= 0 && countrys[index]) {
              item.disabled =
                item.countryRegionCode && item.enabled === 0 ? false : true
              item.key = countrys[index].key + '_' + idx
              item._countryCode_ = countrys[index].countryRegionCode
              item.isLeaf = true
              if (countrys[index].children) {
                // countrys[index].disabled = true
                countrys[index].selectable = false
                countrys[index].children.push(item)
              } else {
                // countrys[index].disabled = true
                countrys[index].selectable = false
                countrys[index].children = []
                countrys[index].children.push(item)
              }
            }
          })
          console.log('appCode', countrys)
          state.countrys = countrys
          state.states = states
          const list = countrys.filter(item => item.children?.length)
          state.areaList = list
          state.modalAreaList = list.map(i => {
            return {
              ...i,
              disabled: false
            }
          })
        }
      },
      terminalOptions: [
        { value: 1, label: 'WEB' },
        { value: 2, label: 'APP' }
      ],
      payVisible: false,
      record: null,
      edit: false,
      moveThemeSort: (fromIndex, toIndex) => {
        // 从数组中移除元素并插入到新位置
        let arr = state.formState.themeTypeSort
        const element = arr.splice(fromIndex, 1)[0]
        arr.splice(toIndex, 0, element)
        state.formState.themeTypeSort = [...arr]
      },
      modalTitle: '新增',
      changeVisible: async (visible = false, record = null, type = 'add') => {
        state.payVisible = visible
        if (type === 'add' && visible === true) {
          // 新增
          state.modalTitle = '新增'
          state.formState = {
            enable: null,
            areaCodes: [],
            themeTypeSort: []
          }
          const { success, data } = await theme_coldWarm_themeList_get({
            ...state.searchParams
          })
          if (success) {
            state.formState.themeTypeSort = data
          }
        }
        if (type === 'view') {
          // 查看
        }
        if (type === 'edit') {
          state.modalTitle = '编辑'
          // 编辑
          const { success, data } = await theme_coldWarm_detail_id_get({
            id: record.id
          })
          if (success) {
            state.formState = data
            let areaCodes = []
            data.areaList.forEach(i => {
              // let countryCode = i.countryCode
              // let key_1 = null
              // state.countrys.forEach(i => {
              //   if (i.countryRegionCode === countryCode) {
              //     key_1 = i.key
              //   }
              // })
              let provinceName = i.provinceName
              let countryCode = i.countryCode
              let key_2 = null
              state.states.forEach(i => {
                if (
                  i.nameEn === provinceName &&
                  i._countryCode_ === countryCode
                ) {
                  key_2 = i.key
                }
              })
              areaCodes.push(`${key_2}`)
            })
            state.formState.areaCodes = areaCodes
            console.log(areaCodes)
          }
        }
        state.edit = record ? true : false
      },
      deleteRow: async record => {
        const { id } = record
        const { success, retInfo } = await theme_coldWarm_delete_id_delete({
          id
        })
        if (success) {
          message.success('删除成功')
          state.pagination.pageNum = 1
          state.initList()
        } else {
          message.error(retInfo)
        }
      },
      watchPage: e => {
        state.pagination.pageNum = e
        state.initList()
      },
      logVisible: false, // 日志弹窗
      value: null,
      route: useRoute(),
      router: useRouter(),
      jumpPage: (path, query) => {
        console.log('query ', query)
        state.router.push({ path, query })
      },
      dataSource: [],
      searchParams: {
        terminalId: 1,
        brandId: 1,
        channelId: 1,
        siteId: 1
      },
      brands: [],
      channels: [],
      sites: [],
      resetParams: () => {
        state.filterForm = {
          areaCodes: null,
          enable: null
        }
        state.resetPagination()
        state.initList()
      },
      handleSearchParams: () => {
        state.pagination.pageNum = 1
        state.initList()
      },
      save: async () => {
        //
        if ([0, 1].indexOf(state.formState.enable) < 0) {
          message.error('启用状态必填')
          return
        }
        if (
          !state.formState.areaCodes ||
          state.formState.areaCodes.length === 0
        ) {
          message.error('国家/省州必填')
          return
        }
        let areaCodes = state.formState.areaCodes
        let onlyCountryNum = areaCodes.filter(Number.isFinite)
        console.log('state.formState', state.countrys, state.formState)
        let isHk = false
        if (onlyCountryNum.length > 0) {
          isHk = state.countrys?.[onlyCountryNum[0]]?.appCode === 'HK'
        }
        if (!isHk && onlyCountryNum.length > 0) {
          let errorCountryName = []
          state.countrys.forEach(i => {
            if (onlyCountryNum.indexOf(i.key) >= 0) {
              errorCountryName.push(i.nameEn)
            }
          })
          message.warning(
            `${errorCountryName.join(',')}下暂无可以勾选的省州，请更新主数据`
          )
          return
        }
        let areaList = []
        areaCodes.forEach(i => {
          let obj = {}
          let codes = `${i}`.split('_')
          if (codes[0] + '') {
            obj.countryCode = state.countrys[codes[0]].countryRegionCode
            obj.countryName = state.countrys[codes[0]].nameEn
          }
          if (codes[1] && codes[1] + '') {
            obj.provinceCode = state.states[codes[1]].countryRegionCode
            obj.provinceName = state.states[codes[1]].nameEn
          }
          areaList.push(obj)
        })
        let apis = ''
        if (state.modalTitle === '新增') {
          apis = theme_coldWarm_add_post
        }
        if (state.modalTitle === '编辑') {
          apis = theme_coldWarm_edit_post
        }
        const { success, retInfo } = await apis({
          ...state.formState,
          ...state.searchParams,
          areaList,
          enable: state.formState.enable,
          themeTypeSort: state.formState.themeTypeSort
        })
        if (success) {
          state.payVisible = false
          state.initList()
        } else {
          message.error(retInfo)
        }
      },
      changeFilterTime: timeSet => {
        state.postParams = {
          ...state.postParams,
          createTimeBegin:
            timeSet === null || timeSet.length === 0 ? null : timeSet[0],
          createTimeEnd:
            timeSet === null || timeSet.length === 0 ? null : timeSet[1]
        }
      },

      pagination: {
        pageNum: 1, // 当前页
        pageSize: 10, // 每页的数量
        total: 0 // 总记录数
      },
      resetPagination: () => {
        state.pagination = {
          pageNum: 1, // 当前页
          pageSize: 10, // 每页的数量
          total: 0 // 总记录数
        }
        state.initList()
      },
      logList: [],
      logPagination: {
        pageNum: 1, // 当前页
        pageSize: 5, // 每页的数量
        total: 0 // 总记录数
      },
      changeEnable: async record => {
        Modal.confirm({
          title: '状态修改',
          content:
            record.enable === 0
              ? '确认禁用冷暖区状态吗？'
              : '确认启用冷暖区状态吗？',
          okText: '确认',
          cancelText: '取消',
          onOk: async () => {
            const { success, retInfo } = await theme_coldWarm_enable_post({
              id: record.id,
              enable: record.enable
            })
            if (success) {
              message.success('状态修改成功')
              state.initList()
            } else {
              if (record.enable === 0) {
                record.enable = 1
              } else {
                record.enable = 0
              }
              message.error(retInfo)
            }
          },
          onCancel: () => {
            if (record.enable === 0) {
              record.enable = 1
            } else {
              record.enable = 0
            }
          }
        })
        console.log(record)
      },
      initList: async () => {
        if (state.route.query.terminalId) {
          state.searchParams.terminalId = state.route.query.terminalId - 0
        }
        if (state.route.query.brandId) {
          state.searchParams.brandId = state.route.query.brandId - 0
        }
        if (state.route.query.channelId) {
          state.searchParams.channelId = state.route.query.channelId - 0
        }
        if (state.route.query.siteId) {
          state.searchParams.siteId = state.route.query.siteId - 0
        }
        // payMethod_listConfig_post_(state.searchParams, state)
        let countryCode = null
        let provinceCode = null
        let areaCodes = state.filterForm.areaCodes
        if (areaCodes) {
          let codes = areaCodes ? areaCodes.split('_') : []
          if (codes[0] + '') {
            let index = codes[0]
            countryCode = state.countrys[index].countryRegionCode
          }
          if (codes[1] + '') {
            let index = codes[1]
            provinceCode = state.states[index].countryRegionCode
          }
        }
        const { success, data } = await theme_coldWarm_page_get({
          ...state.searchParams,
          enable: state.filterForm.enable,
          countryCode,
          provinceCode,
          ...state.pagination
        })
        if (success) {
          data.list.forEach(item => {
            item.disableEdit = (item.areaList || [])?.[0]?.countryCode === 'HK'
          })
          state.dataSource = data.list
          console.log('data.list', data.list)
          state.pagination.pageNum = data.pageNum
          state.pagination.total = data.total
          state.pagination.pages = data.pages
        }
      } // 初始化标题列表
    })
    onMounted(() => {
      if (state.route.query.terminalId) {
        state.searchParams.terminalId = state.route.query.terminalId - 0
      }
      if (state.route.query.brandId) {
        state.searchParams.brandId = state.route.query.brandId - 0
      }
      if (state.route.query.channelId) {
        state.searchParams.channelId = state.route.query.channelId - 0
      }
      if (state.route.query.siteId) {
        state.searchParams.siteId = state.route.query.siteId - 0
        state.router.replace({ query: {} })
      }
      common_querySiteInfo_get_({
        state
      })
      state.getCountryState()
      state.initList()
    })

    provide('initState', state)
    return {
      ...toRefs(state)
    }
  }
}
</script>
<style scoped>
.collection-container {
  margin: 20px;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
}
</style>
